import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, Manager } from "../stores/store_types"

const callSalesAPI = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, salesManagers: Array<Manager>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/sales",
    {
      headers: headers
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callSalesAPI }
